<template>
  <Card>
    <CardHeader>
      <CardTitle>Allow reapplication</CardTitle>
      <CardDescription>Let this candidate reapply to other roles.</CardDescription>
      <CardAction>
        <Switch
          :model-value="contact.reapplyAllowed"
          aria-label="Allow reapplication"
          @update:model-value="value => emit('update', value)"
        />
      </CardAction>
    </CardHeader>
  </Card>
</template>

<script setup lang="ts">
import { Card, CardHeader, CardTitle, CardDescription, CardAction } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import type { ContactDetail } from '../ContactDetail';

defineProps<{ contact: ContactDetail }>();

const emit = defineEmits<{ update: [value: boolean] }>();
</script>
